


















import Vue from 'vue'

export interface Taller {
  img: string
  title: string
  link: string
  concluded?: boolean
}

export interface TalleresComponentData {
  talleres: Taller[]
}

export default Vue.extend({
  data: (): TalleresComponentData => ({
    talleres: [
      {
        img: '/images/taller1.png',
        title:
          'Aplicación Práctica de Técnicas de Procesamiento del Lenguaje Natural (NLP)',
        link: 'https://youtu.be/a47lOxCfl08',
        concluded: true,
      },
      {
        img: '/images/taller2.png',
        title: 'Cómo diseñar un videojuego: Desde la Idea al GamePlay',
        link: 'https://youtu.be/cx796J1czpk',
        concluded: true,
      },
      {
        img: '/images/taller3.png',
        title: 'Password Cracking',
        link: 'https://youtu.be/kRKcyMFaYp8',
        concluded: true,
      },
    ],
  }),
})
